import { render } from "./ProcessPayment.vue?vue&type=template&id=181883e6&scoped=true&ts=true"
import script from "./ProcessPayment.vue?vue&type=script&lang=ts"
export * from "./ProcessPayment.vue?vue&type=script&lang=ts"

import "./ProcessPayment.vue?vue&type=style&index=0&id=181883e6&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181883e6"]])

export default __exports__